import axios from 'axios';
import { getApiBaseUrl } from '../utils/config';

const api = axios.create({
  baseURL: getApiBaseUrl(),
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Auth endpoints
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  registerWithInvite: (data) => api.post('/auth/register-with-invite', data),
  login: (data) => api.post('/auth/login', data),
  forgotPassword: (data) => api.post('/auth/forgot-password', data),
  resetPassword: (data) => api.post('/auth/reset-password', data),
  getProfile: () => api.get('/auth/profile'),
  updateSettings: (data) => api.put('/auth/settings', data),
};

// Member endpoints
export const memberAPI = {
  getAll: () => api.get('/members'),
  getById: (id) => api.get(`/members/${id}`),
  create: (formData) => {
    return api.post('/members', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  update: (id, formData) => {
    return api.put(`/members/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  delete: (id) => api.delete(`/members/${id}`),
  removePhoto: (id) => api.delete(`/members/${id}/photo`),
};

// Relationship endpoints
export const relationshipAPI = {
  getAll: (memberId) => api.get('/relationships', { params: memberId ? { member_id: memberId } : {} }),
  create: (data) => api.post('/relationships', data),
  delete: (id) => api.delete(`/relationships/${id}`),
};

// Relationship recommendation endpoints
export const relationshipRecommAPI = {
  getAll: (memberId) => api.get('/relationship-recomm', { params: memberId ? { member_id: memberId } : {} }),
  getCount: () => api.get('/relationship-recomm/count'),
  apply: (id) => api.post(`/relationship-recomm/${id}/apply`),
  dismiss: (id) => api.post(`/relationship-recomm/${id}/dismiss`),
  regenerate: () => api.post('/relationship-recomm/regenerate'),
};

// Access endpoints
export const accessAPI = {
  grant: (data) => api.post('/access/grant', data),
  revoke: (data) => api.post('/access/revoke', data),
  getList: (memberId) => api.get(`/access/${memberId}`),
  getMyRole: (memberId) => api.get(`/access/${memberId}/my-role`),
};

// Invitation endpoints
export const invitationAPI = {
  create: (memberId, expiresInDays) => api.post('/invitations', { member_id: memberId, expires_in_days: expiresInDays }),
  get: (code) => api.get(`/invitations/${code}`),
  revoke: (code) => api.delete(`/invitations/${code}`),
  listForMember: (memberId) => api.get(`/invitations/member/${memberId}`),
};

// Photo endpoints
export const photoAPI = {
  upload: (formData) => {
    return api.post('/photos/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  getAll: () => api.get('/photos'),
  getById: (id) => api.get(`/photos/${id}`),
  getTimelinePhotos: () => api.get('/photos/timeline'),
  delete: (id) => api.delete(`/photos/${id}`),
  addTag: (photoId, memberId) => api.post(`/photos/${photoId}/tags`, { member_id: memberId }),
  removeTag: (photoId, tagId) => api.delete(`/photos/${photoId}/tags/${tagId}`),
};

export default api;
